import { replace } from 'connected-react-router';
import { onFinishMultiAction } from '../Widget/actions';

import { completeVideoRecording } from '../../utils/recordVideo/recordVideoApi';
import dispatchTrueForOneSecond from '../../utils/dispatchTrueForOneSecond';
import config from '../../config';

export const STORE_VIDEO = 'STORE_VIDEO';
export const IS_SUBMITTING = 'IS_SUBMITTING';
export const IS_BACK_TRANSITION = 'IS_BACK_TRANSITION';
export const RECORD_VIDEO_SEND_EMAIL_SUCCESS = 'RECORD_VIDEO_SEND_EMAIL_SUCCESS';
export const RECORD_VIDEO_NO_EMAIL_SUCCESS = 'RECORD_VIDEO_NO_EMAIL_SUCCESS';
export const SAVED_FIRST_VIDEO = 'SAVED_FIRST_VIDEO';

export const goToInstructionsCard = values => dispatch => {
	if (values.direction === 'back')  dispatchTrueForOneSecond(dispatch, IS_BACK_TRANSITION)
    else dispatchTrueForOneSecond(dispatch, IS_SUBMITTING)

	dispatch(replace('/recordvideo'));
};

export const goToEmailStart = values => dispatch => {
	dispatchTrueForOneSecond(dispatch, IS_SUBMITTING)

	dispatch(replace('/recordvideo/email'));
}

export const continueToConfirmationCard = (
	apiRequestData,
	videoName,
	videoId,
	isEmailAction,
	savedFirstVideo,
	actionIdentifier
) => dispatch => {
	completeVideoRecording(apiRequestData, videoName, videoId)
		.then(data => {
			const baseURL = config['RECORD_VIDEO_URL'];

			dispatch({
				type: STORE_VIDEO,
				payload: {
					videoURL: baseURL + data.videoURL,
					thumbnailURL: data.fullThumbnailURL,
					fullVideoURL: data.fullVideoURL,
					answerId: data.recordVideoAnswerId
				}
			});

			if (!savedFirstVideo) dispatch({ type: SAVED_FIRST_VIDEO });

			dispatchTrueForOneSecond(dispatch, IS_SUBMITTING)
			
			if (isEmailAction) dispatch(replace('/recordvideo/successtoemail'));
			else {
				dispatch({ 
					type: RECORD_VIDEO_NO_EMAIL_SUCCESS,
					payload: { actionIdentifier }
				});
				dispatch(replace('/recordvideo/noemailsuccess'));
			}
		})
		.catch(e => console.log('completeVideoRecording error:', e));
};

export const continueToMultiActionsCard = actionIdentifier => dispatch => onFinishMultiAction(actionIdentifier)(dispatch);